import theme from '@theme';
import Skeleton from 'react-loading-skeleton';

import InformationsContainer from './InformationContainer';
import ReportCardContainer from './ReportCardContainer';
import Separator from './Separator';

const ReportElementSkeleton: React.FC = () => {
  return (
    <ReportCardContainer>
      <InformationsContainer>
        <Skeleton
          count={1}
          width={45}
          height={16}
          baseColor={theme.palette.grey[200]}
          borderRadius={4}
        />
        <Separator />
        <Skeleton
          count={1}
          width={52}
          height={16}
          baseColor={theme.palette.grey[200]}
          borderRadius={4}
        />
        <Separator />
        <Skeleton
          count={1}
          width={47}
          height={16}
          baseColor={theme.palette.grey[200]}
          borderRadius={4}
        />
        <Separator />
        <Skeleton
          count={1}
          width={132}
          height={16}
          baseColor={theme.palette.grey[200]}
          borderRadius={4}
        />
      </InformationsContainer>
      <Skeleton
        count={1}
        width={22}
        height={16}
        baseColor={theme.palette.grey[200]}
        borderRadius={4}
      />
    </ReportCardContainer>
  );
};

export default ReportElementSkeleton;
